/**
 * プレイリスト追加シートの開閉状態
 *
 * 曲メニュー（各行にある「…」）から開くため、シート本体は MiniPlayer 側で
 * 1つだけマウントし、開閉だけをこのストアで共有する。
 */

import { create } from 'zustand'

type PlaylistPickerState = {
  /** 追加対象の曲。null の間はシートを開かない */
  episodeIds: number[] | null
  openPlaylistPicker: (episodeIds: number[]) => void
  closePlaylistPicker: () => void
}

export const usePlaylistPicker = create<PlaylistPickerState>((set) => ({
  episodeIds: null,
  openPlaylistPicker: (episodeIds) => set({ episodeIds }),
  closePlaylistPicker: () => set({ episodeIds: null }),
}))
